// import jwtDecode from "jwt-decode";
//
// export function isAuthTokenExpired(authToken) {
//     if (!authToken) {
//         console.error("Auth token is null");
//         return false;
//     }
//     try {
//         const jwt = jwtDecode(authToken);
//         const isExpired = jwt.exp < Date.now() / 1000;
//         return isExpired;
//     } catch (error) {
//         console.error("Token not valid", error);
//         return true;
//     }
// }

export function deleteAllRepowerCookies() {
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i];
        let eqPos = cookie.indexOf("=");
        let name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
        if ((name.startsWith(".AspNet.") && name.endsWith("Cookies")) || name.startsWith("OpenIdConnect")) {
            deleteCookie(name);
        }
    }
}

function deleteCookie(name) {
    document.cookie = name + "=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT";
}
